export const ITEMS_PER_PAGE = [10, 20, 50];
export const ROLE_USER = {
  SUPER_ADMIN: 1,
  MASTER_ADMIN: 2,
  USER: 3,
  ALL: 10,
};
export const STATUS_USER = {
  RESIGN: 0,
  ACTIVE: 1,
  ALL: 10,
};

export const USER_SETTING_CATEGORIES = {
  MACHINE_INPUT: "machine_input",
  USER_SEARCH: "user_search",
  DEPARTMENT_UPDATE: "department_update",
  MACHINE_UPDATE: "machine_update",
  TEMPLATE_MANAGEMENT: "template_management",
  APPROVAL_SETTINGS: "approval_settings",
  UNFINISH_LIST: "unfinish_list",
  SEARCH: "search",
  JUDGMENT: "judgment",
  GROUP_UPDATE: "group_update",
  INSPECTION_STATUS: "inspection_status",
  INSPECTION_SHEET: "inspection_sheet",
  REGISTER_TREATMENT: "register_treatment",
};

export const INSPECTION_ITEM_JUDGMENT_INPUT_TYPE = {
  NUMBER: 1,
  TEXT: 2,
};

export const MAX_FILE_SIZE = 50;
export const MAX_FILE_SIZE_COMMENT = 5;
export const MAX_FILE_COUNT_COMMENT = 5;
export const MAX_ALL_FILE_SIZE_COMMENT = 15;
export const REFRESH_INTERVAL = 540000;
export const PAGE_DEFAULT = 1;
export const PER_PAGE_DEFAULT = 10;
export const MAX_IMPORT_FILE_SIZE = 5;

export const REDIRECT_FAILED = "REDIRECT_FAILED";
export const PREVIOUS_PAGE = 'previous_page';
